import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { fmtMsg, isGuid, MessageHelper, NotificationType } from "@/commonui/utils";
import { Icon, Spin, Row, Col } from "ant-design-vue";
import { QuickViewWindowType } from "@/util/enum";
import { CommonLocale } from "@/locales/localeid";
import { isNull, isUndefined } from "lodash";
import { QuickViewContentModel, QuickViewExposureModel, QuickViewWindowService } from "@/services/quick-view-window";
import { toTimeString } from "@/util/func";
import { QuickViewExtraModel } from "./model";
import { ActionItem } from "commonui";

@Component({
	components: { Icon, Spin, Row, Col, ActionItem }
})
export default class QuickViewWindow extends Vue {
	@Prop({ default: QuickViewWindowType.Content }) quickViewType: any;
	@Prop({ default: null }) id: any;
	@Prop({ default: () => {} }) extra: QuickViewExtraModel | undefined;
	@Prop({ default: false }) loading: boolean | undefined;
	@Prop({ default: null }) contentData: QuickViewContentModel | undefined;
	@Prop({ default: null }) exposurData: QuickViewExposureModel | undefined;
	@Prop({ default: null }) title: any;
	@Prop({ default: false }) isExposureSlotAdded: boolean | undefined;
	@Prop({ default: true }) showContentText: boolean | undefined;

	created() {}

	secondsToTimeString(second: number) {
		return toTimeString(second);
	}

	get commonLocale() {
		return CommonLocale;
	}

	get showContentSection() {
		return !this.loading && this.quickViewType === QuickViewWindowType.Content && !isNull(this.contentData);
	}

	get showExposureSection() {
		return !this.loading && this.quickViewType === QuickViewWindowType.Exposure && !isNull(this.exposurData);
	}

	localizedString(id: string, params?: {}) {
		return fmtMsg(id, params);
	}
}
